import { useNavigate, useLocation } from 'react-router-dom';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { Button, Box, CircularProgress } from '@mui/material';
import SecurityIcon from '@mui/icons-material/Security';
import EmailIcon from '@mui/icons-material/Email';
import VpnKeyIcon from '@mui/icons-material/VpnKey';
import { useDispatch } from 'react-redux';
import { sendMagicLink } from '../../store/twoFAlice';
import { showMessage } from 'app/store/fuse/messageSlice';
import { useState } from 'react';

function AuthPage() {
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();

    const email = location?.state?.email;
    const type = location?.state?.type;
    const password = location?.state?.password;
    const authConfig = location?.state?.data;

    const [loading, setLoading] = useState(false);
    const [disabledAll, setDisabledAll] = useState(false);

    const handleAuthMethod = (method) => {
        if (disabledAll) return;

        if (method === 'authenticator') {
            if (type === "2Fa") {
                navigate("/enable-2fa", { state: { email, password, data: authConfig } });
            } else if (type === "2Fa Verify") {
                navigate('/verify-2fa', { state: { email, password, data: authConfig } });
            }
        }

        if (method === 'backup_codes') {
            navigate('/verify-backup-code', { state: { email, password, data: authConfig } });
        }

        if (method === 'magiclink') {
            setDisabledAll(true);
            setLoading(true);

            setTimeout(() => {
                dispatch(sendMagicLink({ email }))
                    .unwrap()
                    .then(() => {
                        setLoading(false);
                        navigate('/auth/check-email', { state: { email, password } });
                    })
                    .catch((error) => {
                        setLoading(false);
                        setDisabledAll(false);

                        dispatch(
                            showMessage({
                                message: error?.message || "Unable to send email",
                                variant: "error"
                            })
                        );
                    });
            }, 1500);
        }
    };

    return (
        <div className="flex flex-col items-center flex-auto min-w-0 sm:justify-center">
            <Paper className="w-full min-h-full px-16 py-32 sm:w-auto sm:min-h-auto rounded-0 sm:p-48 sm:rounded-2xl sm:shadow">
                <div className="flex flex-col items-center justify-center w-full mx-auto max-w-320 sm:w-320 sm:mx-0">
                    <img className="w-60" src="assets/images/logo/logo.svg" alt="logo" />

                    <Typography className="mt-16 text-center">
                        {email ? "Choose Authentication Method" : "Unauthenticated Access"}
                    </Typography>


                    <Box className="flex flex-col w-full max-w-xs gap-16 mt-24">
                        {authConfig?.currentUser?.is2FaEnabled && (
                            <Button
                                variant="contained"
                                color="secondary"
                                startIcon={<SecurityIcon />}
                                disabled={disabledAll}
                                onClick={() => handleAuthMethod('authenticator')}
                            >
                                Authenticator App
                            </Button>
                        )}

                        {authConfig?.currentUser?.isBackupCodesGenerated && (authConfig?.currentUser?.is2FaMagicLinkEnabled || authConfig?.currentUser?.is2FaEnabled) && (
                            <Button
                                variant="contained"
                                color="secondary"
                                startIcon={<VpnKeyIcon />}
                                disabled={disabledAll}
                                onClick={() => handleAuthMethod('backup_codes')}
                            >
                                Backup Codes
                            </Button>
                        )}

                        {authConfig?.currentUser?.is2FaMagicLinkEnabled && (
                            <Button
                                variant="contained"
                                color="secondary"
                                startIcon={!loading && <EmailIcon />}
                                disabled={disabledAll}
                                onClick={() => handleAuthMethod('magiclink')}
                            >
                                {loading ? <CircularProgress size={22} color="inherit" /> : "Magic Link"}
                            </Button>
                        )}
                    </Box>
                </div>
            </Paper>
        </div>
    );
}

export default AuthPage;